import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ServiceLayer } from '../../../services/serviceLayer';
import { DAO } from './../../../../app/modal/DAO';
import { LandingComponent } from '../.././landing/landing.component';
import * as _ from 'lodash';
import { Settings } from '../../../services/settings';
@Component({
  selector: 'app-search-quotes',
  templateUrl: './quotes.component.html',
  // styleUrls: ['./quotes.component.css']
})
export class QuotesComponent implements OnInit {
  public quotesList:any = [];
  public initialQuoteList: any = []
  public suggestpolicies = [];
  public searchQuoteModal : any;
  public WantToList:any = [];
  public wantedId:any;
  public statusValue:boolean=false;
  public viewALL:boolean=false;
  public quoteGrid:boolean=true;
  public showCancelPopup:boolean=false;
  public currentPolicy:any;
  constructor(private serviceLayer:ServiceLayer,public dao:DAO,public datepipe:DatePipe,
    public LandingComponent:LandingComponent,private settings:Settings) { }

  ngOnInit(): void {
    this.initialQuoteList=this.getQuotes();
    this.WantToList = [
      {"label":"Report a claim","value":"Report a claim"},
      {"label":"Manage my policy","value":"Manage my policy"},
      {"label":"Request Evidence of insurance","value":"Request Evidence of insurance"},
      {"label":"Cancel my policy","value":"Cancel my policy"}
    ]
  }
  //==========get quotes details based on loged in user mail id========
  async getQuotes(){
    // var result = (window.localStorage.getItem("policyQuotesList") != "undefined" ? JSON.parse(window.localStorage.getItem("policyQuotesList")):null);
    var result = await this.serviceLayer.getSearchPoliciesList('')
    if(result != undefined && result != null) {
      this.quotesList=result.filter(s => s.typeName == 'Quote');
    }
    if(this.quotesList.length>0) {
      this.quotesList.forEach(element => {
        element.value = null;
      });
      var WantToList = [
        { "label": "Report a claim", "value": "Report a claim", "disabled": false },
        { "label": "Manage a policy", "value": "Manage my policy", "disabled": false },
        { "label": "Request Evidence of insurance", "value": "Request Evidence of insurance", "disabled": false },
        { "label": "Cancel a policy", "value": "Cancel my policy", "disabled": false }
      ];
      if (this.quotesList != undefined && this.quotesList.length > 0) {
        this.quotesList.forEach(policy => {
          policy['wantedTo'] = _.cloneDeep(WantToList);
          if (['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION', 'EXPIRED'].includes(policy.status.toUpperCase())) {
            policy['wantedTo'][3].disabled = true;
          }
        });
      }
      if(this.quotesList.length>0) {
        this.quotesList.forEach(element => {
          element.expireDate = this.datepipe.transform(element.expireDate,"MM/dd/yyyy")
          element.effectiveDate =  this.datepipe.transform(element.effectiveDate,"MM/dd/yyyy")
          element.value = null;
        });      
      }
      return this.quotesList;
    }
  }

  clickReferenceNumber(data) {
    window.open(this.settings.quickQuotePolicyUrl + "RetrieveQuote?companyCode="+data.companyCode+"&productCode="+data.productCode+"&referenceNumber="+data.referenceNumber)
  }

  PolicyWantedTo(policyDetails) {
    //==QuoteWantedTo===
    if(policyDetails.value == 'Cancel my policy'){
      // this.currentPolicy = policyDetails;
      // this.showCancelPopup = true;
    }
  }

  //=======serach button click========
  async searchQouteDetails(){
    
  }

  popUpClose(event) {
    this.showCancelPopup = false;
    var currentPolicy = this.quotesList.filter(x=>x.referenceNumber == event.referenceNumber);
    currentPolicy[0].value = null;
  }

  //=============get color code based on status============
  getColorCode(status) {
    return this.serviceLayer.getColorCode(status)
  }
   //==============load policy number into auto complete box===========
   async getQuoteBasedOnNumber(event) {
    this.suggestpolicies = [];
    this.suggestpolicies=await this.serviceLayer.getTheQuoteNumber(this.initialQuoteList,event);

  }
  //============get policy based on status=========
  async getQuoteBasedOnFilter() {
    let searchFileter={ SearchValue: this.searchQuoteModal}
    this.quotesList = await this.serviceLayer.getSearchPoliciesList('Quote',searchFileter );
    this.quotesList.forEach(element => {
      element.expireDate = this.datepipe.transform(element.expireDate,"MM/dd/yyyy")
      element.effectiveDate =  this.datepipe.transform(element.effectiveDate,"MM/dd/yyyy")
     });
     return this.quotesList;
    
  }
  //=============export excel================
  async exportExcel(data: any) {
    if(this.quotesList.length >0) {
      let exportColumns=[
        {lable:"Reference Number",fields:'referenceNumber'},
        {lable:"Jobsite Address",fields:'jobSiteAddress'},
        {lable:"Name Insured",fields:'nameInsured'},
        {lable:"Quote Name",fields:'quoteName'},
        // {lable:"Effective Date",fields:'effectiveDate',rule:"this.datepipe.transform(new Date({0}), 'MM/dd/yyyy') "},
        // {lable:"Expire Date",fields:'expireDate',rule:"this.datepipe.transform(new Date({0}), 'MM/dd/yyyy') "},
        {lable:"Effective Date",fields:'effectiveDate'},
        {lable:"Expire Date",fields:'expireDate'},
      ];
      await this.serviceLayer.exportExcel(data.value,exportColumns,'quoteDetail');
    }
  }

  //======View all data=============
  ViewAll() {
    if(this.viewALL) {
      this.viewALL = false;
      this.quoteGrid = true;
    }
    else {
      this.viewALL = true;
      this.quoteGrid = false;
    }
  }
}
